'use client'

import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { ChevronLeft, ChevronRightIcon, X } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'
import { navConfigCareAndShare } from '../nav-config'
import { MobileNavFooter } from './mobile-nav-footer'

type Props = {
  onCloseNav: () => void
}

export const MobileCareShare: React.FC<Props> = ({ onCloseNav }) => {
  const [open, setOpen] = useState(false)
  const t = useTranslations('header')
  return (
    <Sheet open={open}>
      <SheetTrigger asChild>
        <div
          className='flex w-full items-center justify-between rounded-lg bg-light px-5 py-3'
          onClick={() => setOpen(true)}
          ga-tracking-value={`menu__care_and_share`}
          ga-tracking-label={t('nav.care_and_share.title')}
        >
          <p className='font-sans text-sm font-medium uppercase text-neutral-800'>
            {t('nav.care_and_share.title')}
          </p>

          <div className='flex items-center space-x-4'>
            <Image
              alt='care and share logo'
              width={73}
              height={25}
              src='https://mcdn.coolmate.me/image/February2025/mceclip0.png'
            />
            <Button variant='white' size={'icon'} className='bg-neutral-200'>
              <ChevronRightIcon
                strokeWidth={3}
                className='!size-6 stroke-neutral-800 group-hover:stroke-light'
              />
            </Button>
          </div>
        </div>
      </SheetTrigger>

      <SheetContent
        showCloseButton={false}
        side='left'
        className='scrollbar max-h-screen w-full overflow-y-auto bg-light p-0 pb-24'
        aria-describedby='mobile-nav'
      >
        <SheetTitle className='hidden'></SheetTitle>
        <div className='w-full space-y-3 bg-neutral-200 p-4'>
          <div className='flex items-center justify-between'>
            <Button
              variant='ghost'
              onClick={() => setOpen(false)}
              className='flex h-6 w-6 items-center justify-center bg-neutral-200 p-0 text-neutral-600'
              size={'icon'}
            >
              <ChevronLeft size={28} strokeWidth={3} />
            </Button>

            <h3 className='font-sans text-sm font-semibold uppercase text-neutral-900'>
              {t('nav.care_and_share.title')}
            </h3>

            <Button
              variant='ghost'
              onClick={() => {
                setOpen(false)
                onCloseNav()
              }}
              className='flex h-6 w-6 items-center justify-center bg-neutral-200 p-0 text-neutral-400'
              size={'icon'}
            >
              <X size={28} strokeWidth={3} />
            </Button>
          </div>

          <div className='rounded-2xl bg-light px-5.5 py-2 pb-6'>
            {/* <p className='mb-3 font-sans text-sm font-bold text-neutral-900'>
              Dự án
            </p>

            <ul className='space-y-3'>
              {navConfigCareAndShare.specialCollections.map((collection) => (
                <li key={collection.href}>
                  <Link
                    href={collection.href}
                    className='flex items-center gap-2 border-b border-b-neutral-100 pb-2 font-sans text-sm text-neutral-600'
                  >
                    <Image
                      alt={collection.title}
                      width={44}
                      height={44}
                      className='rounded-full'
                      src={ImageHelper.getImageUrl(collection.img, '', 88)}
                    />
                    {collection.title}
                  </Link>
                </li>
              ))}
            </ul> */}

            <p className='mb-2 mt-4 text-center font-sans text-sm font-normal text-neutral-900/70'>
              {t(navConfigCareAndShare.description)}
            </p>
            <Image
              src={ImageHelper.getImageUrl(
                navConfigCareAndShare.imageMobile,
                '',
                590
              )}
              width={295}
              height={140}
              className='h-[140px] w-full rounded-lg object-cover'
              alt={t(navConfigCareAndShare.title)}
            />
            <Button asChild className='mx-auto mt-5 block w-fit'>
              <Link
                href={navConfigCareAndShare.href}
                ga-tracking-value={`menu__care_and_share__cta`}
                ga-tracking-label={t(navConfigCareAndShare.buttonText)}
              >
                {t(navConfigCareAndShare.buttonText)}
              </Link>
            </Button>
          </div>
        </div>
        <SheetFooter className='flex-col px-10 py-4 sm:flex-col'>
          <MobileNavFooter />
        </SheetFooter>
      </SheetContent>
    </Sheet>
  )
}
